import { Controller } from "@hotwired/stimulus";

// Shows or hides a details panel. The panel holds a lazy Turbo Frame, which
// fetches its content the first time the panel becomes visible.
export default class extends Controller {
  static targets = ["panel"];

  toggle(event) {
    event.preventDefault();
    this.panelTarget.hidden = !this.panelTarget.hidden;
  }
}
